export const SET_EXTRA_ACTIVITIES = 'SET_EXTRA_ACTIVITIES'
export const SET_EXTRA_ACTIVITY = 'SET_EXTRA_ACTIVITY'
export const SET_EXTRA_ACTIVITY_PROPERTIES = 'SET_EXTRA_ACTIVITY_PROPERTIES'
export const SET_EXTRA_ACTIVITY_ASSIGNMENTS = 'SET_EXTRA_ACTIVITY_ASSIGNMENTS'
export const SET_EXTRA_ACTIVITIES_DIFFICULTIES = 'SET_EXTRA_ACTIVITIES_DIFFICULTIES'
